import http from '@/plugins/axios/axios';

export default class AutorizacaoSuporteService {

    salvar(requisicao) {       
        return http.post('/api/autorizacao-suporte/salvar', requisicao);
    }

    atualizarRefAcessoSuporte(requisicao) {       
        return http.post('/api/autorizacao-suporte/atualizar-ref-acesso', requisicao);
    }

    excluir(requisicao) {       
        return http.post('/api/autorizacao-suporte/excluir', requisicao);
    } 

    listar(idEmpresa, ano, mes) {       
        return http.get('/api/autorizacao-suporte/listar?idEmp='+idEmpresa+'&a='+ano+'&m='+mes);
    }   
}